import React, { useState, useEffect } from "react";
import { useNotes } from "../contextjs/NotesContext";
import { Card, Button, Modal, Form } from "react-bootstrap";

const Notes = () => {
    const { notes, fetchAllNotes, addNote, editNote, removeNote } = useNotes();
    const [showModal, setShowModal] = useState(false);
    const [selectedNote, setSelectedNote] = useState(null);
    const [formData, setFormData] = useState({ title: "", content: "", reminder_date: "" });

    useEffect(() => {
        fetchAllNotes();
    }, [fetchAllNotes]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (selectedNote) {
            await editNote(selectedNote.id, formData); // edit existing note
        } else {
            await addNote(formData);
        }
        setShowModal(false);
        setFormData({ title: "", content: "", reminder_date: "" }); // reset form
        setSelectedNote(null);
    };

    const handleEditNote = (note) => {
        setSelectedNote(note);
        setFormData({
            title: note.title,
            content: note.content,
            reminder_date: new Date(note.reminder_date).toLocaleDateString("en-CA")
        });
        setShowModal(true);
    }

    return (
        <div>
            <Button onClick={() => {
                setFormData({ title: "", content: "", reminder_date: "" });
                setSelectedNote(null);
                setShowModal(true)
            }}>Add Note</Button>

            {notes.map((note) => (
                <Card key={note.id}>
                    <Card.Body>
                        <Card.Title>{note.title}</Card.Title>
                        <Card.Subtitle>{new Date(note.reminder_date).toLocaleDateString("en-GB")}</Card.Subtitle>
                        <Card.Text>{note.content}</Card.Text>
                        <Button variant="warning" onClick={() => handleEditNote(note)} className="button-spacing">Edit</Button>
                        <Button variant="danger" onClick={() => removeNote(note.id)}>Delete</Button>
                    </Card.Body>
                </Card>
            ))}

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Form onSubmit={handleFormSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedNote ? "Edit Note" : "Add Note"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                value={formData.title}
                                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Content</Form.Label>
                            <Form.Control
                                value={formData.content}
                                onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Reminder Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={formData.reminder_date}
                                onChange={(e) => setFormData({ ...formData, reminder_date: e.target.value })}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
                        <Button variant="primary" type="submit">Save</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
};

export default Notes;